import { render } from "./GesTesisY.vue?vue&type=template&id=33869713&scoped=true"
import script from "./GesTesisY.vue?vue&type=script&lang=js"
export * from "./GesTesisY.vue?vue&type=script&lang=js"

import "./GesTesisY.vue?vue&type=style&index=0&id=33869713&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33869713"

export default script